<template>
  <div class="success-page">
    <div class="container">
      <div class="success-card" data-aos="zoom-in">
        <div class="success-icon">
          <i class="fas fa-check-circle"></i>
        </div>
        
        <h1 class="success-title">Order Placed Successfully!</h1>
        <p class="success-message">Thank you for your order. We've received your payment.</p>
        
        <div v-if="order" class="order-details">
          <div class="detail-row">
            <span class="label">Order Number:</span>
            <span class="value">{{ order.orderNumber }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Total Amount:</span>
            <span class="value">₹{{ order.totalAmount }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Payment Status:</span>
            <span class="value status-paid">{{ order.paymentStatus }}</span>
          </div>
        </div>
        
        <p class="confirmation-note">
          A confirmation email has been sent to your email address.
        </p>
        
        <div class="action-buttons">
          <button @click="$router.push('/shop')" class="btn-continue">
            <i class="fas fa-shopping-bag"></i>
            Continue Shopping
          </button>
          <button @click="$router.push(`/order/${orderId}`)" class="btn-view-order">
            <i class="fas fa-receipt"></i>
            View Order Details
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderService from '../services/OrderService';
import { useToast } from 'vue-toast-notification';

export default {
  name: 'OrderSuccess',
  data() {
    return {
      orderId: null,
      order: null
    }
  },
  methods: {
    async loadOrder() {
      const $toast = useToast();
      try {
        const response = await OrderService.getOrder(this.orderId);
        this.order = response.data.data;
      } catch (error) {
        $toast.error('Failed to load order details');
      }
    }
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
    if (this.orderId) {
      this.loadOrder();
    }
    
    if (typeof AOS !== 'undefined') {
      AOS.init({ duration: 600 });
    }
  }
}
</script>

<style scoped>
.success-page {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 20px 60px 20px;
  background: #f8fafb;
}

.success-card {
  background: white;
  border-radius: 20px;
  padding: 60px 40px;
  max-width: 600px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
}

.success-icon {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #48bb78, #38a169);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.success-icon i {
  font-size: 3rem;
  color: white;
}

.success-title {
  font-family: 'Playfair Display', serif;
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 15px;
}

.success-message {
  font-size: 1.1rem;
  color: #718096;
  margin-bottom: 30px;
}

.order-details {
  background: #f8fafb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #e2e8f0;
}

.detail-row:last-child {
  border-bottom: none;
}

.label {
  font-weight: 600;
  color: #4a5568;
}

.value {
  font-weight: 700;
  color: #2d3748;
}

.status-paid {
  color: #48bb78;
  text-transform: uppercase;
  font-size: 0.9rem;
}

.confirmation-note {
  color: #718096;
  font-size: 0.95rem;
  margin-bottom: 30px;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-continue,
.btn-view-order {
  padding: 14px 28px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-continue {
  background: linear-gradient(135deg, rgb(118, 172, 175), rgb(98, 152, 155));
  color: white;
}

.btn-continue:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(118, 172, 175, 0.4);
}

.btn-view-order {
  background: white;
  color: rgb(118, 172, 175);
  border: 2px solid rgb(118, 172, 175);
}

.btn-view-order:hover {
  background: rgb(118, 172, 175);
  color: white;
}

@media (max-width: 768px) {
  .success-card {
    padding: 40px 20px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
  
  .btn-continue,
  .btn-view-order {
    width: 100%;
    justify-content: center;
  }
}
</style>